import urlUtils from "./url"
import { auth } from "../firebase"
import { signOut } from "firebase/auth"

export default async (reason) => {
  // Sign out from Firebase
  try {
    if (auth.currentUser) {
      await signOut(auth)
    }
  } catch (error) {
    console.error("Error signing out from Firebase:", error)
  }

  // Clean up localStorage
  localStorage.removeItem("token")
  localStorage.removeItem("refresh_token")
  localStorage.removeItem("permissions")
  localStorage.removeItem("tokenIssuedAt")
  localStorage.removeItem("email")

  // Redirect to login page
  window.location.replace("/")
}
